import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavigation from './AdminNavigation';

const AdminLayout = () => {
    return (
        <div className="flex flex-col lg:flex-row min-h-[calc(100vh-80px)] pt-16 md:pt-20 bg-cream">
            {/* Sidebar - Hidden on mobile, handled by AdminNavigation responsive classes */}
            <AdminNavigation />

            {/* Main Content Area */}
            <div className="flex-1 w-full min-w-0">
                <Outlet />
            </div>
        </div>
    );
};

export default AdminLayout;
